/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import type { RouteObject } from "react-router"
import { Navigate } from "react-router"

import { AppRoutes } from "../../routes/routes"
import { AccessDeniedView } from "../access-denied/access-denied-view"
import { AllApplicationTypesView } from "../all-application-types/all-application-types-view"
import { AllOrganizationsView } from "../all-organizations/all-organizations-view"
import { AllUsersView } from "../all-users/all-users-view"
import { ApkDetailView } from "../apk-detail/apk-detail-view"
import { ApplicationListView } from "../application/application-list-view"
import { ApplicationDetailView } from "../application-detail/application-detail-view"
import { ApplicationResultView } from "../application-search/application-search-view"
import { ApplicationTypeDetailView } from "../application-type/application-type-detail-view"
import { DashboardView } from "../dashboard/dashboard-view"
import { GetSdkView } from "../get-sdk/get-sdk-view"
import { LoggerView } from "../logger/logger-view"
import { LoginView } from "../login/login-view"
import { PageNotFoundView } from "../page-not-found/page-not-found-view"
import { PasswordResetView } from "../password-reset/password-reset-view"
import { withLoading } from "../ui-widgets/loading/with-loading"
import { UserDetailView } from "../user-detail/user-detail-view"
import { UserSettingsView } from "../user-settings/user-settings-view"

export const childrenRoutes: RouteObject[] = [
    {
        path: AppRoutes.Login,
        element: <LoginView />
    },
    {
        path: AppRoutes.Home,
        element: <Navigate to={AppRoutes.Dashboard} />
    },
    {
        path: AppRoutes.Dashboard,
        element: withLoading(DashboardView)
    },
    {
        path: AppRoutes.GetSDK,
        element: withLoading(GetSdkView)
    },
    {
        path: AppRoutes.Settings,
        element: withLoading(UserSettingsView)
    },
    {
        path: AppRoutes.ResetPassword,
        element: <PasswordResetView />
    },
    {
        path: AppRoutes.Logs,
        element: <LoggerView />
    },
    {
        path: AppRoutes.AccessDenied,
        element: <AccessDeniedView />
    },
    {
        path: AppRoutes.PageNotFound,
        element: <PageNotFoundView />
    },
    {
        path: "*",
        element: <PageNotFoundView />
    },
    {
        path: AppRoutes.AllOrganizations,
        element: withLoading(AllOrganizationsView)
    },
    {
        path: AppRoutes.AllUsers,
        element: withLoading(AllUsersView)
    },
    {
        path: AppRoutes.UserDetail,
        element: withLoading(UserDetailView)
    },
    {
        path: AppRoutes.AllApplicationTypes,
        element: withLoading(AllApplicationTypesView)
    },
    {
        path: AppRoutes.ApplicationTypeDetail,
        element: withLoading(ApplicationTypeDetailView)
    },
    {
        path: AppRoutes.Application,
        element: withLoading(ApplicationListView)
    },
    {
        path: AppRoutes.ApplicationDetail,
        element: withLoading(ApplicationDetailView)
    },
    {
        path: AppRoutes.ApplicationSearch,
        element: withLoading(ApplicationResultView)
    },
    {
        path: AppRoutes.ApkDetail,
        element: withLoading(ApkDetailView)
    }
]
